// extracted by mini-css-extract-plugin
export default {"container":"CreateListing_container__0Mdv6","text":"CreateListing_text__zPWT5"};